import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class TeamQueryCriteriaClass extends BaseCriteriaModel {
  //hdr table
    namespace?: Optional<string> = Optional.empty();
    group_type?: Optional<string> = Optional.empty();
    name?: Optional<string> = Optional.empty();
    description?: Optional<string> = Optional.empty();
    /**
    * @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5
    */
    guids ?: Optional<string> = Optional.empty();

  //ext table
    param_code?: Optional<string> = Optional.empty();
    param_name?: Optional<string> = Optional.empty();
    param_type?: Optional<string> = Optional.empty();
    value_string?: Optional<string> = Optional.empty();

  //link subject to grp
    app_grp_guid?: Optional<string> = Optional.empty();
    app_subject_guid?: Optional<string> = Optional.empty();
    title?: Optional<string> = Optional.empty();
    ranks?: Optional<string> = Optional.empty();
}

export class TeamCriteriaModelQuery {
  query = '';

  constructor(TeamCriteriaModel: TeamQueryCriteriaClass) {

    if (!TeamCriteriaModel) {
      return;
    }

    this.query += TeamCriteriaModel.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += TeamCriteriaModel.group_type.filter(x => x !== '').map(x => '&group_type=' + x).orElse('');
    this.query += TeamCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += TeamCriteriaModel.description.filter(x => x !== '').map(x => '&description=' + x).orElse('');
    this.query += TeamCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += TeamCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += TeamCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += TeamCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += TeamCriteriaModel.app_grp_guid.filter(x => x !== '').map(x => '&app_grp_guid=' + x).orElse('');
    this.query += TeamCriteriaModel.app_subject_guid.filter(x => x !== '').map(x => '&app_subject_guid=' + x).orElse('');
    this.query += TeamCriteriaModel.title.filter(x => x !== '').map(x => '&title=' + x).orElse('');
    this.query += TeamCriteriaModel.ranks.filter(x => x !== '').map(x => '&ranks=' + x).orElse('');

    this.query += '&status=' + TeamCriteriaModel.status;
    this.query += '&orderBy=' + TeamCriteriaModel.orderBy;
    this.query += '&order=' + TeamCriteriaModel.order;
    this.query += '&offset=' + TeamCriteriaModel.offset + '&limit=' + TeamCriteriaModel.limit;
  }
}
